import { render, staticRenderFns } from "./Approved.vue?vue&type=template&id=46ed2b0c&scoped=true&"
import script from "./Approved.vue?vue&type=script&lang=js&"
export * from "./Approved.vue?vue&type=script&lang=js&"
import style0 from "./Approved.vue?vue&type=style&index=0&id=46ed2b0c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.9.6_fb85a9817f99bdf862e5e3a442a1fb91/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46ed2b0c",
  null
  
)

export default component.exports